export const USER_ROLES = {
  ADMIN: 'admin',
  BUWELO: 'mssAdmin',
  GROUP: 'group',
  MEMBER: 'member',
  PARTNER: 'partner',
  PHARMACY: 'pharmacy',
  PHYSICIAN: 'physician',
  SUPER_ADMIN: 'superAdmin',
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];
